import { withAlpha } from "@/lib/color";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * FootballNews — sezione homepage con notizie di calciomercato + prestazioni
 * aggregate da feed RSS pubblici (Gazzetta, Calciomercato.it, Google News).
 * Solo lettura, gratis, nessuna chiave. I link aprono la fonte in una nuova tab.
 */
const CAT_COLOR = {
    mercato: "rgb(var(--tc-ff7a1a))",
    prestazioni: "rgb(var(--tc-2bb6ff))",
    calcio: "rgb(var(--tc-7ce38b))",
};

function timeAgo(iso) {
    if (!iso) return "";
    const diff = (Date.now() - new Date(iso).getTime()) / 1000;
    if (diff < 3600) return `${Math.max(1, Math.round(diff / 60))} min fa`;
    if (diff < 86400) return `${Math.round(diff / 3600)} h fa`;
    return `${Math.round(diff / 86400)} g fa`;
}

export default function FootballNews({ limit = 9 }) {
    const [items, setItems] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const { data } = await api.get("/news", { params: { limit } });
                if (!cancelled) setItems(data.items || []);
            } catch {
                if (!cancelled) setError(true);
            }
        })();
        return () => { cancelled = true; };
    }, [limit]);

    if (error) return null;

    if (items === null) {
        return (
            <div className="op-label text-t8f95a3 animate-pulse" data-testid="news-loading">
                // CARICAMENTO NOTIZIE…
            </div>
        );
    }
    if (items.length === 0) return null;

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="football-news">
            {items.map((n, idx) => {
                const color = CAT_COLOR[n.category] || "rgb(var(--tc-2bb6ff))";
                return (
                    <a
                        key={`${n.link}-${idx}`}
                        href={n.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="op-card p-4 flex flex-col gap-2 group transition-colors hover:border-t2bb6ff border-l-4"
                        style={{ borderLeftColor: color }}
                        data-testid={`news-item-${idx}`}
                    >
                        <div className="flex items-center justify-between gap-2">
                            <span
                                className="op-label text-[9px] px-2 py-0.5 border"
                                style={{ color, borderColor: `${withAlpha(color, "66")}` }}
                            >
                                {n.category}
                            </span>
                            <span className="op-mono text-[10px] text-t5c6370">{timeAgo(n.published)}</span>
                        </div>
                        <div className="text-tffffff text-sm leading-snug group-hover:text-t2bb6ff transition-colors">
                            {n.title}
                        </div>
                        <div className="op-mono text-[10px] text-t8f95a3 mt-auto pt-1 truncate">
                            {n.source}
                        </div>
                    </a>
                );
            })}
        </div>
    );
}
